import { Fragment, useEffect, useState } from "react";
import PrimaryButton, {
  SecondaryButton,
} from "../../../../../util/Btns/PrimaryButton";
import GraphicPicker from "../../../../../util/graphic-picker/graphic-picker";
import TextError from "../../../../../util/formcomponents/TextError";
import { ErrorMessage } from "formik";
import appPreviewIcon from "../../../../../Assets/applifecycle/appPreviewIcon.png";
import thumbnailPreviewIcon from "../../../../../Assets/applifecycle/thumbnailPreviewIcon.png";
import promotionalBannerSmall from "../../../../../Assets/applifecycle/promotionalBannerSmall.png";
import promotionalBannerLarge from "../../../../../Assets/applifecycle/promotionalBannerLarge.png";
import {
  useUpdateAppstoreGraphics,
  useUploadGraphics,
} from "../../../../../hooks/DevAppHooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import screenshotPreviewIcon from "../../../../../Assets/applifecycle/screenShotPreviewicon.png";
import { Checkbox, FormControlLabel } from "@material-ui/core";

export const UploadCreatives = ({
  id,
  initialValues,
  setPublishStoreData,
  storeListingUploadBuild,
  match,
  setStoreListingValues,
}) => {
  const { mutate: uploadGraphicsMutate } = useUploadGraphics(id);
  // const { mutate: updateAppstoreGraphics } = useUpdateAppstoreGraphics();
  const history = useHistory();
  const [icon, setIcon] = useState(
    initialValues?.builds?.[0]?.graphics?.appIcon
      ? initialValues?.builds?.[0]?.graphics?.appIcon
      : {}
  );
  const [thumbnail, setThumbnail] = useState(
    initialValues?.builds?.[0]?.graphics?.thumbnail
      ? initialValues?.builds?.[0]?.graphics?.thumbnail
      : {}
  );
  const [banner, setBanner] = useState(
    initialValues?.builds?.[0]?.graphics?.bannerSmall
      ? initialValues?.builds?.[0]?.graphics?.bannerSmall
      : {}
  );
  const [bannerLarge, setBannerLarge] = useState(
    initialValues?.builds?.[0]?.graphics?.bannerLarge
      ? initialValues?.builds?.[0]?.graphics?.bannerLarge
      : {}
  );
  const [builds, setBuilds] = useState([{}]);
  const [applyAsAbove, setApplyAsAbove] = useState(false);

  useEffect(() => {
    let values = JSON.parse(JSON.stringify(initialValues.builds));
    if (initialValues?.platform?.length !== values?.length) {
      for (let i = values?.length; i < initialValues?.platform?.length; i++) {
        values[i] = {
          platform: initialValues?.platform?.[i],
          graphics: {
            screenshots: [],
          },
        };
      }
    }
    let temp = JSON.parse(JSON.stringify(values)).map((el) => {
      let screenshotsArr = [];
      if (el?.graphics?.screenshots) {
        screenshotsArr = [...el?.graphics?.screenshots, {}];
      } else {
        screenshotsArr = [{}];
      }
      return {
        ...el,
        graphics: {
          ...el.graphics,
          screenshots: screenshotsArr,
        },
      };
    });
    setBuilds(temp);
  }, []);

  // Removed useEffect that was causing unnecessary rebuilds
  // The "add empty slot" logic is now handled in onComplete

  const buttonState = () => {
    let disable = true;
    if (
      icon?.url &&
      banner?.url &&
      thumbnail?.url &&
      bannerLarge?.url &&
      !builds.some((e) => e.graphics?.screenshots?.length <= 2)
    ) {
      disable = false;
    }
    return disable;
  };

  const handleSubmit = (publishStore = false) => {
    let graphics = {};
    initialValues.platform.forEach((plat) => {
      let findIndex = builds.findIndex((el) => el.platform === plat);
      graphics[plat] = {
        appIcon: icon,
        bannerLarge: bannerLarge,
        bannerSmall: banner,
        thumbnail: thumbnail,
        screenshots: builds?.[findIndex]?.graphics?.screenshots.filter(
          (el) => JSON.stringify(el) !== "{}" && el?.url !== ""
        ),
      };
    });
    if (publishStore === false) {
      if (Object.keys(graphics)?.length !== 0) {
        uploadGraphicsMutate(graphics);
      }
      // if (initialValues?.activeRelease) {
      //   updateAppstoreGraphics(graphics);
      // }
      // history.push(`${match.url}/release-management`);
    } else if (publishStore === true) {
      setStoreListingValues(graphics);
    }
  };

  const handleCheckbox = (event) => {
    const value = event.target.checked;
    if (value) {
      let temp = [];
      initialValues.platform.forEach((item) => {
        temp.push({
          graphics: builds?.[0].graphics,
          platform: item,
        });
      });
      setBuilds(temp);
    }
    setApplyAsAbove(value);
  };

  return (
    <>
      <div className="step-container">
        <div className="picker-container  img-container">
          <div className="app-wrapper common-container">
            <div className="info-text">
              <span className="text-white">
                App Icon
                <span className="text-light-red"> *</span>
              </span>
              <span className="info-msg">
                Please upload app icon below (Please try to avoid using the
                black background for the image)
              </span>
            </div>
            <div className="wrapper">
              <div className="error-msg">
                <ErrorMessage
                  component={TextError}
                  name={"graphics.appIcon.url"}
                />
              </div>
              <GraphicPicker
                width="175px"
                height="175px"
                dimensionCheck={{ width: 256, height: 256 }}
                fileTypeCheck={".jpeg, .jpg"}
                applicationId={id}
                graphicName="app-icon"
                preview={icon?.url ? icon.url : undefined}
                defaultPreview={appPreviewIcon}
                onComplete={(data) => {
                  delete data?.fileName;
                  setIcon(data);
                }}
                type="image"
              />
            </div>

            {/* <span>Your app icon as shown in the XR app store</span> */}
          </div>
          <div className="thumbnail-wrapper common-container">
            <div className="info-text">
              <span className="text-white">
                Thumbnail
                <span className="text-light-red"> *</span>
              </span>
              <span className="info-msg">
                Please upload thumbnail image below (Please try to avoid using
                the black background for the image)
              </span>
            </div>
            <div className="wrapper">
              <div className="error-msg">
                <ErrorMessage
                  component={TextError}
                  name={"graphics.thumbnail.url"}
                />
              </div>
              <GraphicPicker
                width="512px"
                height="256px"
                dimensionCheck={{ width: 512, height: 256 }}
                fileTypeCheck={".jpeg, .jpg"}
                applicationId={id}
                graphicName="thumbnail"
                preview={thumbnail?.url}
                defaultPreview={thumbnailPreviewIcon}
                onComplete={(data) => {
                  delete data?.fileName;
                  setThumbnail(data);
                }}
                type="image"
              />
            </div>
          </div>
        </div>

        {/* Promotional Banner  */}
        <div className="picker-container">
          <div className="feature-wrapper ">
            <div className="wrapper common-container">
              <div className="info-text">
                <span className="text-white">
                  Promotional Banner (Small)
                  <span className="text-light-red"> *</span>
                </span>
                <span className="info-msg">
                  Please upload small promotional banner image below.
                </span>
              </div>
              <div className="error-msg">
                <ErrorMessage
                  component={TextError}
                  name={"graphics.bannerSmall.url"}
                />
              </div>

              <GraphicPicker
                width="230px"
                height="215px"
                dimensionCheck={{ width: 320, height: 320 }}
                fileTypeCheck={".jpeg, .jpg"}
                applicationId={id}
                graphicName="app-small"
                preview={banner?.url}
                defaultPreview={promotionalBannerSmall}
                onComplete={(data) => {
                  delete data?.fileName;
                  setBanner(data);
                }}
                type="image"
              />
            </div>

            <div className="wrapper common-container">
              <div className="info-text">
                <span className="text-white">
                  Promotional Banner (Large)
                  <span className="text-light-red"> *</span>
                </span>
                <span className="info-msg">
                  Please upload large promotional banner image below.
                </span>
              </div>
              <div className="error-msg">
                <ErrorMessage
                  component={TextError}
                  name={"graphics.bannerLarge.url"}
                />
              </div>

              <GraphicPicker
                width="512px"
                height="256px"
                dimensionCheck={{ width: 640, height: 320 }}
                fileTypeCheck={".jpeg, .jpg"}
                applicationId={id}
                graphicName="app-large"
                preview={bannerLarge?.url}
                defaultPreview={promotionalBannerLarge}
                onComplete={(data) => {
                  delete data?.fileName;
                  setBannerLarge(data);
                }}
                type="image"
              />
            </div>
          </div>
        </div>
        {/* Screenshot  */}
        {builds?.map((item, idx) => {
          return (
            <div key={item?.platform} className="picker-container">
              <div className="common-container">
                <div className="info-text">
                  <div id="screenshot-header">
                    <span className="text-white">
                      Screenshots for {item?.platform}
                      <span className="text-light-red"> *</span>
                    </span>
                    {idx === 1 && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              builds &&
                              builds?.[0]?.graphics?.screenshots?.length > 1 &&
                              builds.every(
                                (e) =>
                                  JSON.stringify(e.graphics?.screenshots) ===
                                  JSON.stringify(
                                    builds?.[0]?.graphics?.screenshots
                                  )
                              )
                            }
                            onChange={handleCheckbox}
                          />
                        }
                        label="Apply as above"
                        style={{ color: "white", marginBottom: 0 }}
                      />
                    )}
                  </div>

                  <span className="info-msg">
                    Please upload 5 screenshots of your application below.
                    Minimum 2 required
                  </span>
                </div>
                <div className="wrapper">
                  {item?.graphics?.screenshots &&
                    item?.graphics?.screenshots?.map((el, index) => {
                      return (
                        <Fragment key={el?.url ? el.url + index : index}>
                          <GraphicPicker
                            width="312px"
                            height="175px"
                            dimensionCheck={{ width: 1280, height: 720 }}
                            fileTypeCheck={".jpeg, .jpg"}
                            applicationId={id}
                            graphicName="app-large"
                            preview={el?.url ? el?.url : undefined}
                            defaultPreview={screenshotPreviewIcon}
                            onComplete={(data) => {
                              delete data?.fileName;
                              let temp = JSON.parse(JSON.stringify(builds));
                              if (temp?.[idx]?.graphics?.screenshots?.[index]) {
                                temp[idx].graphics.screenshots[index] = data;
                                
                                // Add empty slot if needed (max 5 screenshots)
                                const currentScreenshots = temp[idx].graphics.screenshots.filter(
                                  (item) => item?.url !== "" && JSON.stringify(item) !== "{}"
                                );
                                if (currentScreenshots.length < 5) {
                                  temp[idx].graphics.screenshots = [...currentScreenshots, {}];
                                } else {
                                  temp[idx].graphics.screenshots = currentScreenshots;
                                }
                                
                                setBuilds(temp);
                              }
                            }}
                            type="image"
                          />
                        </Fragment>
                      );
                    })}
                </div>
              </div>
            </div>
          );
        })}
        {/* Button============ */}
        <div
          className="d-flex justify-content-between mt-3"
          style={{ justifyContent: "flex-end" }}
        >
          <div className="d-flex">
            {initialValues?.builds && initialValues?.builds?.[0]?.graphics ? (
              <>
                <SecondaryButton
                  className="mrc-15 secondary-btn-appManage"
                  disabled={buttonState()}
                  onClick={(e) => {
                    e.preventDefault();
                    setPublishStoreData();
                    handleSubmit(true);
                  }}
                >
                  Publish Store Listing
                </SecondaryButton>
                <PrimaryButton
                  disabled={buttonState()}
                  onClick={(e) => {
                    handleSubmit();
                  }}
                >
                  Upload New Build
                </PrimaryButton>
              </>
            ) : (
              <PrimaryButton
                disabled={buttonState()}
                onClick={(e) => {
                  handleSubmit();
                }}
              >
                Next
              </PrimaryButton>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
